import type { DashboardNewestConversionItemDto } from '@/types/dashboard'

/**
 * The lead id a Newest Conversions row opens with, or null when it has nothing to open.
 *
 * The two scopes resolve against different endpoints, and getting this wrong is a 404 rather than a
 * wrong-looking page:
 *
 * - Campaign scope pairs the row's own campaign-scoped `LeadId` with the campaign it sits in, which
 *   the campaign contact endpoint reads as a single point read.
 * - Workspace scope needs `WorkspaceLeadId`. The workspace contact endpoint matches only the deduped
 *   representative-per-email set, so the raw campaign lead id is not in it and 404s. The server
 *   leaves the field null for an identity with no representative — a lead carrying no email address
 *   never enters that set — and such a row simply has no workspace profile to open.
 */
export function conversionAnchorLeadId(
  conversion: Pick<DashboardNewestConversionItemDto, 'LeadId' | 'WorkspaceLeadId'>,
  campaignId?: string,
): string | null {
  if (campaignId) {
    return conversion.LeadId
  }
  return conversion.WorkspaceLeadId ?? null
}
